<template>
  <div v-if="centerDialogVisible" class="center-dialog drag-box" v-drag id="drag">
    <div class="dialog-header">
      <span class="circle" v-bind:style="{ background: backgroundColor }"></span>
      <span class="text">{{ activeFeature.name }}</span>
      <div class="ctrl">
        <span class="fa fa-close" @click="toggleShow(false)"></span>
      </div>
    </div>
    <div class="content" v-if="/文物资源/.test(activeFeature.type) == false">
      <div class="left">
        <div class="images">
          <el-carousel height="202px" indicator-position="none">
            <el-carousel-item v-if="!activeFeature.imglist">
              <img style="width: 100%; height: 100%" src="../../../assets/altimg.png" />
            </el-carousel-item>
            <el-carousel-item>
              <img style="width: 100%; height: 100%" :src="activeFeature.cover" alt="封面图片不存在"
                @click="bigImgDialogVisible = true" />
            </el-carousel-item>
            <el-carousel-item v-show="activeFeature.imglist" v-for="url in activeFeature.imglist" :key="url">
              <img style="width: 100%; height: 100%" :src="url" alt="图片不存在" @click="bigImgDialogVisible = true" />
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="base-info">
          <ul>
            <li>地址：{{ activeFeature.address }}</li>
            <li>区域：{{ activeFeature.caidstr }}</li>
            <li v-if="activeFeature.ccidstr.indexOf('民') == -1">
              经度：{{ activeFeature.longitude }}
            </li>
            <li v-if="activeFeature.ccidstr.indexOf('民') == -1">
              纬度：{{ activeFeature.latitude }}
            </li>
            <li v-if="false">海拔：{{ activeFeature.altitude }}</li>
            <li>类别：{{ activeFeature.ccidstr }}</li>
            <li>等级或称号：{{ activeFeature.levelname }}</li>
            <li>认定时间：{{ activeFeature.statetime }}</li>
          </ul>
        </div>
      </div>
      <div class="right">
        <div class="tabs">
          <span @click="lswmClick()" v-bind:class="{ active: activeGroup == 1 }">历史文脉</span>
          <span @click="ccfaClick()" v-bind:class="{ active: activeGroup == 2 }">传承方案</span>
        </div>
        <div class="base-infos" v-show="activeGroup == 0">
          <div class="header">历史文脉</div>
          <div class="content">
            <div>
              <p v-html="activeFeature.lswm
                ? activeFeature.lswm
                : '暂未录入该历史文脉数据'
                "></p>
            </div>
            <div class="docs">
              <ul>
                <li v-for="(item, index) in activeFeature.jjFileList" v-bind:key="index" :title="item.title">
                  <a v-bind:href="item.filepath" target="_blank">
                    <span v-if="item.ext == 'doc' || item.ext == 'docx'" class="fa fa-file-word-o"></span>
                    <span v-if="item.ext == 'pdf'" class="fa fa-file-pdf-o"></span>
                    <span v-if="item.ext == 'ppt' || item.ext == 'pptx'" class="fa fa-file-powerpoint-o"></span>
                    <span v-if="item.ext == 'xls' || item.ext == 'xlsx'" class="fa fa-file-excel-o"></span>
                    <span v-if="item.ext == 'csv'" class="fa fa-file-text-o"></span>
                    <span>{{ item.title }}</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="wenmai" v-show="activeGroup == 1">
          <div class="header">历史文脉</div>
          <div class="content">
            <div>
              <p v-html="activeFeature.lswm"></p>
            </div>
            <div v-if="activeFeature.booklistData">
              <div v-for="(item, index) in activeFeature.booklistData" v-bind:key="index">
                <a v-bind:href="item.url" target="_blank">
                  {{ item.title }}
                </a>
              </div>
            </div>
            <div class="docs">
              <ul>
                <li v-for="(item, index) in activeFeature.lswmFileList" v-bind:key="index" :title="item.title">
                  <a v-bind:href="item.filepath" target="_blank">
                    <span v-if="item.ext == 'doc' || item.ext == 'docx'" class="fa fa-file-word-o"></span>
                    <span v-if="item.ext == 'pdf'" class="fa fa-file-pdf-o"></span>
                    <span v-if="item.ext == 'ppt' || item.ext == 'pptx'" class="fa fa-file-powerpoint-o"></span>
                    <span v-if="item.ext == 'xls' || item.ext == 'xlsx'" class="fa fa-file-excel-o"></span>
                    <span v-if="item.ext == 'csv'" class="fa fa-file-text-o"></span>
                    <span>{{ item.title }}</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="chuancheng" v-show="activeGroup == 2">
          <div class="header">传承方案</div>
          <div class="content">
            <div>
              <p v-html="activeFeature.ccfa"></p>
            </div>
            <div v-if="activeFeature.booklistData">
              <div v-for="(item, index) in activeFeature.booklistData" v-bind:key="index">
                <a v-bind:href="item.url" target="_blank">
                  {{ item.title }}
                </a>
              </div>
            </div>
            <div class="docs">
              <ul>
                <li v-for="(item, index) in activeFeature.ccfaFileList" v-bind:key="index" :title="item.title">
                  <a v-bind:href="item.filepath" target="_blank">
                    <span v-if="item.ext == 'doc' || item.ext == 'docx'" class="fa fa-file-word-o"></span>
                    <span v-if="item.ext == 'pdf'" class="fa fa-file-pdf-o"></span>
                    <span v-if="item.ext == 'ppt' || item.ext == 'pptx'" class="fa fa-file-powerpoint-o"></span>
                    <span v-if="item.ext == 'xls' || item.ext == 'xlsx'" class="fa fa-file-excel-o"></span>
                    <span v-if="item.ext == 'csv'" class="fa fa-file-text-o"></span>
                    <span>{{ item.title }}</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content" v-if="/文物资源/.test(activeFeature.type)">
      <div class="left">
        <div class="images">
          <el-carousel height="202px" indicator-position="none">
            <el-carousel-item v-if="!activeFeature.imglist">
              <img style="width: 100%; height: 100%" src="../../../assets/altimg.png" />
            </el-carousel-item>
            <el-carousel-item>
              <img style="width: 100%; height: 100%" :src="activeFeature.cover" alt="封面图片不存在"
                @click="bigImgDialogVisible = true" />
            </el-carousel-item>
            <el-carousel-item v-show="activeFeature.imglist" v-for="url in activeFeature.imglist" :key="url">
              <img style="width: 100%; height: 100%" :src="url" alt="图片不存在" @click="bigImgDialogVisible = true" />
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="base-info">
          <ul>
            <li>地址：{{ activeFeature.location }}</li>
            <li>经度：{{ activeFeature.longitude }}</li>
            <li>纬度：{{ activeFeature.latitude }}</li>
            <li>类别：{{ activeFeature.levelname }}</li>
            <li>等级或称号：{{ activeFeature.levelname }}</li>
            <li>认定时间：{{ activeFeature.statetime }}</li>
          </ul>
        </div>
      </div>
      <div class="right" style="width: 385px">
        <!-- <div class="tabs">
          <span>简介</span>
        </div> -->
        <div class="base-infos" v-show="activeGroup == 0">
          <div class="header">简介</div>
          <div class="content">
            <div>
              <p v-html="activeFeature.desc ? activeFeature.desc : '暂未录入数据'
                "></p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog class="big-img-dialog" :visible.sync="bigImgDialogVisible" width="100%" append-to-body>
      <div class="dialog-header">
        <div class="ctrl">
          <span class="fa fa-close" @click="bigImgDialogVisible = false"></span>
        </div>
      </div>
      <div class="content">
        <el-carousel height="100%" width="100%" indicator-position="none">
          <el-carousel-item v-if="!activeFeature.imglist">
            <img style="height: 100%" src="../../../assets/altimg.png" />
          </el-carousel-item>
          <el-carousel-item>
            <img style="height: 100%" :src="activeFeature.cover" alt="封面图片不存在" />
          </el-carousel-item>
          <el-carousel-item v-show="activeFeature.imglist" v-for="url in activeFeature.imglist" :key="url">
            <img style="height: 100%" :src="url" alt="图片不存在" />
          </el-carousel-item>
        </el-carousel>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "SearchResultDialog",
  props: {
    activeFeature: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      bigImgDialogVisible: false,
      centerDialogVisible: false,
      activeGroup: 0,
      backgroundColor: "#fff",
      isShowDrag: false,
    };
  },
  //自定义指令
  directives: {
    drag: {
      // 指令的定义
      bind: function (el) {
        let oDiv = el; // 获取当前元素
        oDiv.onmousedown = (e) => {
          console.log("onmousedown");
          // 算出鼠标相对元素的位置
          let disX = e.clientX - oDiv.offsetLeft;
          let disY = e.clientY - oDiv.offsetTop;

          document.onmousemove = (e) => {
            // 用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
            let left = e.clientX - disX;
            let top = e.clientY - disY;

            oDiv.style.left = left + "px";
            oDiv.style.top = top + "px";
          };

          document.onmouseup = (e) => {
            document.onmousemove = null;
            document.onmouseup = null;
          };
        };
      },
    },
  },
  watch: {
    activeFeature() {
      this.legend.forEach((item) => {
        if (item.type == this.activeFeature.type) {
          this.backgroundColor = item.color.fill;
        }
      });
    },
  },
  computed: {
    legend() {
      return this.$store.state.legend;
    },
  },
  components: {},
  methods: {
    lswmClick() {
      if (this.activeGroup == 0) {
        this.activeGroup = 1;
      } else if (this.activeGroup == 1) {
        this.activeGroup = 0;
      } else {
        this.activeGroup = 1;
      }
    },
    ccfaClick() {
      if (this.activeGroup == 0) {
        this.activeGroup = 2;
      } else if (this.activeGroup == 2) {
        this.activeGroup = 0;
      } else {
        this.activeGroup = 2;
      }
    },
    toggleShow(data) {
      this.centerDialogVisible = data;
      if (!data) {
        this.xxMap.clearLocation();
      }
    },
  },
  mounted() { },
};
</script>

<style scoped lang="less" >
::v-deep.big-img-dialog {
  .el-dialog {
    margin-top: 0 !important;
    width: 100%;
    height: 100%;
    margin-bottom: 0;
  }

  .el-dialog__header {
    display: none !important;
  }

  .el-dialog__body {
    padding: 0 !important;
    height: 100%;
    overflow: hidden;
  }

  .el-dialog {
    background-color: #070707ce !important;
    border-radius: 5px;
    padding: 10px;
  }

  .dialog-header {
    padding: 0 0 10px 0;

    .ctrl {
      float: right;

      span:nth-child(1) {
        padding: 0px 10px 0 5px;
        color: #f5f5f5;
        font-size: x-large;
      }

      span:hover {
        cursor: pointer;
        color: #efe1e1;
      }
    }
  }

  .content {
    height: calc(100% - 30px);
    overflow: hidden;
    text-align: center;

    .el-carousel {
      height: 100%;
    }

    .el-carousel__item {
      width: 100%;
      height: 100%;
      text-align: center;
    }
  }
}

.center-dialog {
  position: absolute;
  top: 105px;
  left: 550px;
  z-index: 100;
  margin: auto;
  background-color: #185e9479 !important;
  border-radius: 5px;
  padding: 10px;
  width: 720px;

  .dialog-header {
    color: #fff;
    padding: 0 0 10px 0;
    cursor: move;

    .circle {
      display: inline-block;
      width: 20px;
      height: 20px;
      border-radius: 30px;
      background-color: red;
      vertical-align: middle;
      margin-right: 5px;
      margin-top: -2px;
    }

    .ctrl {
      float: right;

      span:nth-child(1) {
        padding: 0 5px 0 10px;
      }

      span:nth-child(2) {
        padding: 0px 10px 0 5px;
      }

      span:hover {
        cursor: pointer;
        color: #efe1e1;
      }
    }
  }

  .content {
    .left {
      display: inline-block;
      height: 530px;
      width: 290px;
      vertical-align: top;
      background-color: #fff;
      overflow: hidden;

      .images {
        height: 202px;
        margin-bottom: 10px;

        el-image img {
          width: 100%;
          height: 100%;
        }
      }

      .base-info {
        background-image: url(../../../assets/searchbg.png);
        background-size: 100% 100%;
        background-repeat: no-repeat;
        padding-top: 60px;
        padding-left: 10px;
        height: 328px;

        ul {
          list-style-type: none;
          padding-inline-start: 0;

          li {
            line-height: 25px;
          }
        }
      }
    }

    .right {
      display: inline-block;
      width: 400px;
      height: 530px;
      overflow: auto;
      color: #000;
      background-color: #fff;
      margin-left: 10px;
      padding: 10px;

      .tabs {
        span {
          display: inline-block;
          padding: 3px 9px;
          text-align: center;
          color: #fff;
        }

        span:nth-child(1) {
          background-color: #2390f7;
        }

        span:nth-child(2) {
          background-color: #45c3fd;
        }

        span:hover {
          cursor: pointer;
          color: #aae9f8;
        }

        span.active {
          box-shadow: 2px 2px 3px #23a1bf82;
        }
      }

      .header {
        line-height: 40px;
        border-bottom: solid 1px #ccc;
        font-size: large;
        font-weight: bold;
        text-align: center;
        width: 100%;
      }

      .content {
        padding: 20px 10px;
        text-align: center;
        font-family: fangsong sans-serif;

        .lon {
          margin-right: 20px;
        }

        .docs {
          text-indent: 0;
          text-align: center;

          ul {
            list-style-type: none;
            padding-inline-start: 0px;

            li {
              line-height: 25px;
              text-align: left;
              display: inline-block;
              width: 50%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }

          .fa-file-word-o {
            margin-right: 10px;
            color: #307dff;
          }

          .fa-file-pdf-o {
            margin-right: 10px;
            color: #ee635c;
          }

          .fa-file-powerpoint-o {
            margin-right: 10px;
            color: #ff542b;
          }

          .fa-file-excel-o {
            margin-right: 10px;
            color: #307b54;
          }

          .fa-file-text-o {
            margin-right: 10px;
            color: #2fd17d;
          }

          // 'pdf','doc', 'docx', 'xls', 'xlsx', 'csv', 'ppt', 'pptx'
        }
      }

      .base-infos,
      .wenmai,
      .chuancheng {
        .content {
          text-indent: 20px;
          line-height: 25px;
          text-align: left;
        }
      }
    }
  }
}

.drag-box {
  // position: absolute;
  // top: 100px;
  // left: 100px;
  // background: #fff;
  // border-radius: 5px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

/*定义了滚动条整体样式；*/
::-webkit-scrollbar {
  height: 4px !important;
  width: 8px !important;
}

/*定义了滚动条滑块的样式*/
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  border-style: dashed;
  /* background: rgba(157, 165, 183, 0.7); */
  background: rgb(109, 144, 172);
  border-color: #e2242400;
  border-width: 1.5px;
  background-clip: padding-box;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(2, 50, 86, 0.7);
}

/*定义了轨道的样式*/
::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  border-radius: 10px;
  background: rgb(106, 109, 110);
}
</style>

 